import gsap from "gsap";

const 
filters = document.querySelectorAll(".filter"),
mandats = document.querySelectorAll(".mandat");

let current_filter = [];


filters.forEach(el => {
    el.addEventListener("click", () => {
        const type = el.dataset.type
        el.classList.toggle("active");
        if(current_filter.includes(type)){
            current_filter = current_filter.filter(item => item != type);
        }else{
            current_filter.push(type);
        }
        
        if(current_filter.length > 0){
            const mandats_to_hide = document.querySelectorAll(`.mandat:not(.${current_filter.join(" .")})`);
            const mandats_to_show = document.querySelectorAll(`.mandat.${current_filter.join(" .")}`);
            console.log(mandats_to_show);
            
            mandats_to_hide.length > 0 && gsap.to(mandats_to_hide, {
                autoAlpha: 0,
                position: "absolute"
            });
            mandats_to_show.length > 0 && gsap.to(mandats_to_show, {
                autoAlpha: 1,
                position: "relative"
            });
        }else{            
            gsap.to(mandats,{
                autoAlpha: 1,
                position: "relative"
            });
        }

        
    })
})
